var _style, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconViewpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon-viewpoint",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n            .icons_stroke{\r\n                fill:none;\r\n                stroke:currentColor;\r\n                stroke-width:2;\r\n                stroke-linecap:round;\r\n                stroke-linejoin:round;\r\n                stroke-miterlimit:10;\r\n            }\r\n        ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "icons_stroke",
    cx: 12,
    cy: 12,
    r: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icons_stroke",
    d: "M18.2265 11.3805C18.3552 11.634 18.4195 11.7607 18.4195 12C18.4195 12.2393 18.3552 12.366 18.2265 12.6195C17.6001 13.8533 15.812 16.5 12 16.5C8.18799 16.5 6.39992 13.8533 5.77348 12.6195C5.64481 12.366 5.58048 12.2393 5.58048 12C5.58048 11.7607 5.64481 11.634 5.77348 11.3805C6.39992 10.1467 8.18799 7.5 12 7.5C15.812 7.5 17.6001 10.1467 18.2265 11.3805Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icons_stroke",
    d: "M17.5 3.5H17.7C19.4913 3.5 20.387 3.5 20.9435 4.0565C21.5 4.61299 21.5 5.50866 21.5 7.3V7.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icons_stroke",
    d: "M17.5 20.5H17.7C19.4913 20.5 20.387 20.5 20.9435 19.9435C21.5 19.387 21.5 18.4913 21.5 16.7V16.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "icons_stroke",
    d: "M6.5 3.5H6.3C4.50866 3.5 3.61299 3.5 3.0565 4.0565C2.5 4.61299 2.5 5.50866 2.5 7.3V7.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "icons_stroke",
    d: "M6.5 20.5H6.3C4.50866 20.5 3.61299 20.5 3.0565 19.9435C2.5 19.387 2.5 18.4913 2.5 16.7V16.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewpoint);
export default __webpack_public_path__ + "static/media/icon-viewpoint.b95bc15a49bda62b4b88198731cee211.svg";
export { ForwardRef as ReactComponent };